module.exports = __webpack_public_path__ + "img/mail.df0d4774.svg";